/*
  Softech Store - "Buy now" and "Get formal quote" on product pages (Batch 5 item 2, A204, Najam 2 Oct 2026).
  Markup: snippets/softech-product-cta.liquid.

  Buy now: submits the theme's own add-to-cart form (same variant, same quantity, same errors,
  the A176 band logic runs as on Add to cart) and goes to checkout once the cart has the line.
  It is shown only while the theme shows its buy buttons (#buy-buttons-wrapper, the country rule)
  and is disabled whenever Add to cart is disabled.

  Get formal quote: opens the selector quote form (softech-selector-quote.js) with the current
  selection, unit price and quantity.

  Pure helpers are exported for node tests (module.exports).
*/
(function (root) {
  'use strict';

  function money(cents, format) {
    cents = Math.round(Number(cents) || 0);
    if (root.SoftechBands && root.SoftechBands.formatMoney) return root.SoftechBands.formatMoney(cents, format);
    var s = (Math.abs(cents) / 100).toFixed(2).split('.');
    s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (cents < 0 ? '-' : '') + '$' + s.join('.');
  }

  // Text sent with a quote request: "XGS 138 Xstream Protection / Renewal / 36 MOS, SKU ABC, unit price $1,234.00"
  function selectionText(variant, fallback, format) {
    var parts = [];
    var v = variant || fallback || {};
    var title = v.public_title || (v.title && v.title !== 'Default Title' ? v.title : '');
    if (title) parts.push(title);
    if (v.sku) parts.push('SKU ' + v.sku);
    if (v.price != null && v.price !== '') parts.push('unit price ' + money(v.price, format));
    return parts.join(', ');
  }

  var api = { money: money, selectionText: selectionText };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  root.SoftechCta = api;
  if (typeof document === 'undefined') return;

  function q(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function init() {
    var box = q('[data-sbq]');
    if (!box || box.dataset.sbqReady) return;
    box.dataset.sbqReady = '1';

    var info = box.closest('product-info') || document;
    var sticky = q('[data-sbq-sticky]');
    var msg = q('.sbq-msg', box);
    var buyNow = false;
    // constants.js declares PUB_SUB_EVENTS with const: a global name, not a window property.
    var EVENTS = typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS : null;
    var sub = typeof subscribe === 'function' ? subscribe : null;
    var canRedirect = !!(EVENTS && sub && EVENTS.cartUpdate);

    function wrapper() { return document.getElementById('buy-buttons-wrapper'); }
    function form() { return q('form[data-type="add-to-cart-form"]', info); }
    function submitBtn() { var f = form(); return f ? f.querySelector('button[name="add"]') : null; }
    function say(text) { if (!msg) return; msg.textContent = text || ''; msg.hidden = !text; }

    function sync() {
      var w = wrapper(), sb = submitBtn();
      var show = !!(canRedirect && w && sb && root.getComputedStyle(w).display !== 'none');
      var off = !sb || sb.disabled || sb.getAttribute('aria-disabled') === 'true';
      qa('[data-sbq-buy]').forEach(function (b) { b.hidden = !show; b.disabled = off; });
      box.classList.toggle('sbq--one', !show);
      if (sticky) sticky.classList.toggle('sbq--one', !show);
    }

    function buy() {
      var f = form(), sb = submitBtn();
      if (!f || !sb || sb.disabled) return;
      buyNow = true;
      say('Adding to your order...');
      if (typeof f.requestSubmit === 'function') f.requestSubmit(sb); else sb.click();
    }

    function refreshSelection() {
      var el = q('[data-sbq-sel]', box);
      if (!el) return;
      var v = null;
      try { v = JSON.parse(q('variant-selects [data-selected-variant]', info).textContent); } catch (e) {}
      el.textContent = selectionText(v, { sku: box.dataset.sku, price: box.dataset.price }, box.dataset.money);
    }

    function quote() {
      var open = q('.ssq-open', box), f = q('.ssq-form', box);
      if (!f) return;
      refreshSelection();
      if (f.hidden && open) open.click();
      if (f.hidden) f.hidden = false; // the quote script is still loading: show the form anyway
      try { f.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { f.scrollIntoView(); }
      var first = f.querySelector('input');
      if (first) { try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); } }
    }

    document.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('[data-sbq-buy],[data-sbq-quote]') : null;
      if (!t) return;
      if (t.hasAttribute('data-sbq-buy')) buy(); else quote();
    });
    // The quote form reads the selection again when it is sent.
    var qf = q('.ssq-form', box);
    if (qf) qf.addEventListener('submit', refreshSelection, true);

    if (canRedirect) {
      sub(EVENTS.cartUpdate, function (ev) {
        if (!buyNow || !ev || ev.source !== 'product-form') return;
        buyNow = false;
        var base = (root.Shopify && root.Shopify.routes && root.Shopify.routes.root) || '/';
        // Task 7399: a cart below the minimum of 10 or on a 1 MOS term goes to the cart page, not checkout.
        if (root.SoftechMin10 && root.SoftechMin10.refresh) {
          say('Checking your cart...');
          root.SoftechMin10.refresh().then(function (closed) {
            if (closed) { say('Your cart needs a change before checkout.'); root.location.href = base + 'cart'; return; }
            say('Taking you to checkout...');
            root.location.href = base + 'checkout';
          });
          return;
        }
        say('Taking you to checkout...');
        root.location.href = base + 'checkout';
      });
      if (EVENTS.cartError) sub(EVENTS.cartError, function () { buyNow = false; say(''); });
    }

    // Follow the theme: country rule (wrapper shown or hidden) and Add to cart enabled or not.
    var mo = new MutationObserver(sync);
    var w = wrapper();
    if (w) mo.observe(w, { attributes: true, subtree: true, attributeFilter: ['style', 'disabled', 'aria-disabled', 'class'] });
    sync();

    // Phone bar: on while the main buttons are out of view.
    if (sticky) {
      document.body.classList.add('sbq-has-sticky');
      var row = q('.sbq-row', box);
      if ('IntersectionObserver' in root && row) {
        new IntersectionObserver(function (entries) {
          sticky.classList.toggle('is-on', !entries[0].isIntersecting);
        }, { threshold: 0.5 }).observe(row);
      } else {
        sticky.classList.add('is-on');
      }
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})(typeof window !== 'undefined' ? window : this);
